export const isLoggingOut = ref(false)
export async function logout() {
  const auth = useAuth()
  isLoggingOut.value = true
  await auth.logout()
  isLoggingOut.value = false
}
